// extracted by mini-css-extract-plugin
export default {"layout":"About_layout__bjYYG","description":"About_description__Ne+dN"};